import RightRail, { Header, Route, RouterProvider } from '../../../libs/gs-component-right-rail';
import React, { useState } from 'react';

import AddEmailForm from './AddEmailForm';
import EditGuestForm from './EditGuestForm';
import styles from '../rightRails.scss';

export interface Props {
  onClose: () => void;
}

export interface Guest {
  firstName: string;
  lastName: string | null;
  email: string;
}

export enum Routes {
  main = 'main',
  editGuest = 'editGuest',
}

export const AddGuestEmail: React.FC<Props> = ({ onClose }) => {
  const [guests, setGuests] = useState<Guest[]>([]);

  return (
    <RightRail open={true} overlay={false} className={styles.rightRail}>
      <Header onClose={onClose}>Add guests</Header>

      <RouterProvider entry={Routes.main}>
        <Route screen={Routes.main} component={<AddEmailForm onClose={onClose} onAddGuest={setGuests} />} />
        <Route screen={Routes.editGuest} component={<EditGuestForm guests={guests} onClose={onClose} />} />
      </RouterProvider>
    </RightRail>
  );
};
